//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.AECDesign.js";
import "../no/Builder.js";
import "../no/Section.js";
import "../Features/Features.AECDesign.RoofBoundaryListItemBuilderList.js";
import "../no/Expression.js";
import "../Features/Features.AECDesign.LevelReferenceBuilder.js";
import "../Features/Features.AECDesign.MaterialLayersBuilder.js";
import "../no/Features.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/ObjectList.js";
let d=[[[1,"Boundaries",0,"Section",0],[1,"BoundaryList",0,"Features.AECDesign.RoofBoundaryListItemBuilderList",0],[1,"EndLimitDistance",0,"Expression",0],[1,"LevelReference",0,"Features.AECDesign.LevelReferenceBuilder",0],[1,"MaterialLayers",0,"Features.AECDesign.MaterialLayersBuilder",0],[1,"Offset",0,"Expression",0],[1,"OverhangDistance",0,"Expression",0],[1,"StartLimitDistance",0,"Expression",0],[1,"Thickness",0,"Expression",0],[0,"TopType",1,0]],[[[],"CreateRoofBoundaryListItemBuilder",{R_:{roofBoundaryListItemBuilder:"Features.AECDesign.RoofBoundaryListItemBuilder"}},0,0]],[]];
SPLM.Features.AECDesign.RoofBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AECDesign.RoofBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.AECDesign.RoofBuilder.TopOption = Object.freeze({
    "FootprintType" : "FootprintType", "ExtrusionType" : "ExtrusionType"});

export default SPLM;